import { apiClient } from "../api/ApiClient";
import type { Customer } from "../models/Customer";
import type { KeyValue } from "../models/KeyValue";
import { PagedResult } from "../models/PagedResult";
import { SearchParam } from "../models/SearchParam";
import { Status } from "../models/Status";
import { CreateCrudService } from "./CrudServiceFactory";

export function CustomerService() {
  const route = "customer";
  const crudService = CreateCrudService<Customer, KeyValue>({
    Route: "customer",
    EntityName: "Customer",
    PartialFields: ["BusinessName", "Code"],
    LoadingMessage: "Loading customers...",
    SavingMessage: "Saving customer...",
    MapPartial: (value) => ({
      Key: String(value.Code ?? ""),
      Value: String(value.BusinessName ?? ""),
    }),
  });

  const GetActivePartial = async (
    skip = 0,
    limit = 50,
  ): Promise<PagedResult<KeyValue>> => {
    const response = await apiClient.post<PagedResult<Record<string, unknown>>>(
      `${route}/SearchDynamic/${skip}/${limit}`,
      {
        Fields: ["BusinessName", "Code"],
        Filters: [
          {
            Field: "Status",
            Operator: "EQ",
            Value: Status.Active,
          },
        ],
      } as SearchParam,
      {
        busyMessage: "Loading active customers...",
      },
    );

    return {
      ...response.data,
      Data: response.data.Data.map((value) => ({
        Key: String(value.Code ?? ""),
        Value: String(value.BusinessName ?? ""),
      })),
    };
  };

  return {
    ...crudService,
    GetActivePartial,
  };
}
